var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9544_43174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9 15C5.6925 15 3 12.3075 3 9C3 5.6925 5.6925 3 9 3C12.3075 3 15 5.6925 15 9C15 12.3075 12.3075 15 9 15ZM11.91 6.2175L7.5 10.6275L6.09 9.2175C5.7975 8.925 5.325 8.925 5.0325 9.2175C4.74 9.51 4.74 9.9825 5.0325 10.275L6.975 12.2175C7.2675 12.51 7.74 12.51 8.0325 12.2175L12.975 7.275C13.2675 6.9825 13.2675 6.51 12.975 6.2175C12.6825 5.925 12.2025 5.925 11.91 6.2175Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.3667,
    y: 2.44104,
    width: 1.51938,
    height: 19.7519,
    rx: 0.75969,
    transform: "rotate(-45 1.3667 2.44104)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9544_43174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkInactive);
export default __webpack_public_path__ + "static/media/mark-inactive.575360ffff4866d212cbb2472c7cb442.svg";
export { ForwardRef as ReactComponent };